import * as Sentry from '@sentry/nextjs';

const HANDLED_STATUSES = [400, 422];

export function reportUnhandledPaymentErrorToSentry(error: unknown): void {
  const err = error as {
    response?: { status?: number; data?: unknown };
    message?: string;
  };
  const status = err?.response?.status;

  if (status !== undefined && HANDLED_STATUSES.includes(status)) {
    return;
  }

  Sentry.withScope((scope) => {
    if (status !== undefined) {
      scope.setTag('http_status', String(status));
    } else {
      scope.setTag('no_response', 'true');
    }
    if (err?.response?.data && typeof err.response.data === 'object') {
      scope.setExtra('response_data', err.response.data);
    }
    Sentry.captureException(error);
  });
}
